module.exports = __webpack_public_path__ + "static/media/heartipro-charger-5.9d279bc8.png";